module.exports = __webpack_public_path__ + "img/15-Oregon 4.jpg";